<template>
  <div>
    <!-- 题目序号 -->
    <question-number style="margin-bottom: 15px;"/>
    <!-- 操作按钮 -->
    <action-buttons style="margin-bottom: 15px;"/>
  </div>
</template>

<script>
import QuestionNumber from '@views/question-review/packages/QuestionNumber'
import ActionButtons from './TekeOrderReviewButtons'

export default {
  components: {QuestionNumber, ActionButtons},
  mixins: [],
  data () {
    return {
      activeNames: ['1'],
    }
  },
  computed: {
    ...Vuex.mapState({}),
  },
  watch: {},
  beforeCreate () {},
  created () {
    this.$nextTick(() => {})
  },
  mounted () {},
  methods: {
    ...Vuex.mapActions([]),
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/teke-order-review/pages/TekeOrderReviewSidebar.vue